import axios from "axios";
import config from "@/config.js";

const apiClient = axios.create({
  baseURL: `${config.API_BASE_URL}/admin`,
  headers: {
    "Content-Type": "application/json",
    "X-Client-Id": "com.animaapp.admin",
  },
});

apiClient.interceptors.request.use(
  (config) => {
    const { token } = localStorage;
    if (token) {
      config.headers.Authorization = `JWT ${token}`;
    }
    return config;
  },
  (error) => console.error(error)
);

export const baseApiClient = axios.create({
  baseURL: config.API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
    "X-Client-Id": "com.animaapp.admin",
  },
});

export default apiClient;
